import * as PIXI from "pixi.js";

import App from "./App";
import GameScene from "./game/GameScene";

const app = new App(800, 600);
app.init();
